import { useQuery } from "react-query"
import { getOwnPendingsStatisticCardsData } from "api/Pendings";


export const useOwnPendingsStatisticCardsData = () => {
    return useQuery<Array<any> | any>(
      ['ownPendings'],
        () => getOwnPendingsStatisticCardsData(),
        {
            onError(error: any) {
                console.error(error)
            }
        }
    )
}